'use strict';
const angular = require('angular');

/*@ngInject*/
export function ActivationCodesService($resource) {
  return $resource('/api/activation-codes/:id', {
    id: '@_id'
  },{
    createOneTimeCodes: {
      method: 'POST',
      url: '/api/activation-codes/onetime/:count'
    },
    queryBySeed: {
      method: 'GET',
      url: '/api/activation-codes/seed/:seedId',
      isArray: true
    },
    patch: {
      method: 'PATCH'
    },
    deleteSeed: {
      method: 'DELETE',
      url: '/api/activation-codes/seed/:seedId'
    },
    update: {
      method: 'PUT'
    }
  });
}


export default angular.module('conduuApp.ActivationCodesService', [])
  .factory('ActivationCodeService', ActivationCodesService)
  .name;



// WEBPACK FOOTER //
// ./client/services/activation-codes/activation-code.service.js